import React, {useEffect, useState} from 'react';
import {Link, useLocation} from 'react-router-dom';
import Icon from './AppIcon';
import {ExternalLinkIcon} from "lucide-react";

function getLink(item, isActivePath) {
  if (item.external) {
    return <a href={item?.path}
              target="_blank"
              className={`primary-navigation-link ${isActivePath(item?.path) ? 'active' : ''}`}
              rel="noopener noreferrer">
      <span>{item?.label}</span>
      <ExternalLinkIcon height="1.4em" className="m-1"></ExternalLinkIcon>
    </a>
  }
  return <Link key={item?.path}
               to={item?.path}
               className={`primary-navigation-link ${isActivePath(item?.path) ? 'active' : ''}`}>
    {item?.label}
  </Link>;
}

function getMobileLink(item, isActivePath) {
  if (item.external) {
    return <a href={item?.path}
              target="_blank"
              className={`primary-navigation-mobile-link ${isActivePath(item?.path) ? 'active' : ''}`}
              rel="noopener noreferrer">
      <span>{item?.label}</span>
      <ExternalLinkIcon height="20px" className="m-1"></ExternalLinkIcon>
    </a>
  }
  return <Link key={item?.path}
               to={item?.path}
               className={`primary-navigation-mobile-link ${isActivePath(item?.path) ? 'active' : ''}`}>
    {item?.label}
  </Link>;
}

const TopNavigation = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location?.pathname]);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  const navigationItems = [
    {label: 'Product', path: '/product'},
    {label: 'Use Cases', path: '/use-cases'},
    {label: 'Blog', path: '/blog-listing'},
    {label: 'About', path: '/about'},
    {label: 'Contact', path: '/contact'},
    {label: 'Docs', path: 'https://docs.sleeve.dev', external: true},
    {label: 'Sign Up', path: 'https://hub.sleeve.dev', external: true},
  ];

  const isActivePath = (path) => {
    if (path === '/homepage') {
      return location?.pathname === '/' || location?.pathname === '/homepage';
    }
    return location?.pathname?.startsWith(path);
  };

  return (
    <>
      <nav className="primary-navigation">
        <div className="primary-navigation-container">
          <Link to="/homepage" className="primary-navigation-logo">
            <img
              src="/assets/images/SLEEVE-logo-white-1769672699589.png"
              alt="Sleeve"
              className="h-6 w-auto"
            />
          </Link>

          <div className="primary-navigation-menu">
            {navigationItems?.map((item) => getLink(item, isActivePath))}
          </div>

          <button className="primary-navigation-mobile-toggle"
                  onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                  aria-label="Toggle mobile menu"
                  aria-expanded={isMobileMenuOpen}>
            <Icon name={isMobileMenuOpen ? 'X' : 'Menu'}
                  size={24}
                  color="var(--color-primary)"
            />
          </button>
        </div>
      </nav>
      {isMobileMenuOpen && (
        <div className="primary-navigation-mobile-menu animate-fade-in">
          <div className="primary-navigation-mobile-menu-list">
            {navigationItems?.map((item) => getMobileLink(item, isActivePath))}
          </div>
        </div>
      )}
    </>
  );
};

export default TopNavigation;